/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SpotGroupFiltering {
  NON_GROUPED = "nonGrouped",
  ONLY_GROUPS = "onlyGroups",
  ALL = "all",
}
